import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { ButtonMode, ModalButtons, NotificationTheme } from '@fcom/ui-components';
import { LoginStatus, ProfileType } from '@fcom/core-api/login';
import { loginStatus, profileType } from '@fcom/core/selectors';
import { FinnairCart } from '@fcom/dapi/api/models';
import { unsubscribe } from '@fcom/core/utils';
import { BookingAppState } from '@fcom/common/interfaces/booking';

@Component({
  selector: 'fin-pax-shortcut-to-pay',
  templateUrl: 'pax-shortcut-to-pay.component.html',
  styleUrls: ['pax-shortcut-to-pay.component.scss'],
})
export class PaxShortcutToPayComponent implements OnInit, OnDestroy {
  @Input()
  cartData$: Observable<FinnairCart>;

  @Output()
  buttonClick: EventEmitter<{ skipToCheckout: boolean }> = new EventEmitter<{ skipToCheckout: boolean }>();

  readonly NotificationTheme = NotificationTheme;
  readonly ModalButtons = ModalButtons;
  readonly ButtonMode = ButtonMode;

  loginStatus$: Observable<LoginStatus>;
  profileType$: Observable<ProfileType>;
  shortCutFlowActive$: Observable<boolean>;

  private subscription = new Subscription();

  constructor(private store$: Store<BookingAppState>) {}

  ngOnInit(): void {
    this.loginStatus$ = this.store$.pipe(loginStatus());
    this.profileType$ = this.store$.pipe(profileType());

    this.shortCutFlowActive$ = combineLatest([this.cartData$, this.profileType$, this.loginStatus$]).pipe(
      map(([cart, profileType, loginStatus]) => {
        if (loginStatus !== LoginStatus.LOGGED_IN) {
          return false;
        }
        if (profileType === ProfileType.CORPORATE) {
          return true;
        }

        return cart.bounds.every((bound) => {
          return bound.fareFamily.name.toLowerCase().includes('flex');
        });
      })
    );
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscription);
  }
}
